import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { logout } from '@utils/utils';
import CompanySelector from './companySelector';
import ProfileDropdown from './ProfileDropdown'; // import at top
import VoiceAssistant from './VoiceAssist/VoiceAssistant';
import {
  Bell, Mail, Clock, Eye, EyeOff, LogOut, ArrowDown, Globe, ArrowLeft
} from 'lucide-react';
import { API_BASE_URL,APP_BASE_URL } from '../config';
import MiniAssistant from './VoiceAssist/MiniAssistant';
import Webtrix24LogoAnimated from './Webtrix24LogoAnimated';

const mockNotifications = [
  { id: 1, type: 'email', title: 'New Email Received', message: 'You have a new message from support.', time: '2 min ago', read: false },
  { id: 2, type: 'reminder', title: 'Task Reminder', message: 'Follow up with client X.', time: '1 hour ago', read: false },
  { id: 3, type: 'watcher', title: 'Added as Watcher', message: 'You are now watching Lead #123.', time: 'Yesterday', read: true },
  { id: 4, type: 'email', title: 'New Email Received', message: 'You have a new message from support.', time: '2 min ago', read: false },
  { id: 5, type: 'reminder', title: 'Task Reminder', message: 'Follow up with client X.', time: '1 hour ago', read: false },
  { id: 6, type: 'watcher', title: 'Added as Watcher', message: 'You are now watching Lead #123.', time: 'Yesterday', read: true },
  { id: 7, type: 'email', title: 'New Email Received', message: 'You have a new message from support.', time: '2 min ago', read: false },
  { id: 8, type: 'reminder', title: 'Task Reminder', message: 'Follow up with client X.', time: '1 hour ago', read: false },
  { id: 9, type: 'watcher', title: 'Added as Watcher', message: 'You are now watching Lead #123.', time: 'Yesterday', read: true },
  { id: 10, type: 'email', title: 'New Email Received', message: 'You have a new message from support.', time: '2 min ago', read: false },
  { id: 11, type: 'reminder', title: 'Task Reminder', message: 'Follow up with client X.', time: '1 hour ago', read: false },
  { id: 12, type: 'watcher', title: 'Added as Watcher', message: 'You are now watching Lead #123.', time: 'Yesterday', read: true },
];

const iconMap = {
  email: <Mail className="text-blue-500" size={18} />,
  reminder: <Clock className="text-orange-500" size={18} />,
  watcher: <Eye className="text-green-500" size={18} />,
};

const TopNavBar = () => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const dropdownProfileRef = useRef(null);
  const [notifications, setNotifications] = useState(mockNotifications);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showMobileNotificationPage, setShowMobileNotificationPage] = useState(false);
  const unreadCount = 0;//notifications.filter(n => !n.read).length;
  const userData = JSON.parse(localStorage.getItem('user'));
  const [selectedCompany, setSelectedCompany] = useState(localStorage.getItem('active_company') || userData?.default_company);
  const [dateTime, setDateTime] = useState(new Date());
  const systemTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [timeZone, setTimeZone] = useState(localStorage.getItem('user_time_zone') || systemTZ);

  const avatar = userData?.['photo']
      ? `${APP_BASE_URL}/uploads/profilephoto/${userData?.['adminID']}/profilePic/${userData?.['photo']}`
      : null;
  
    const initials = userData?.['name']
      ? userData?.['name']
          .split(' ')
          .map((n) => n[0])
          .join('')
          .substring(0, 2)
          .toUpperCase()
      : 'U';
  

  useEffect(() => {
    const timer = setInterval(() => setDateTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    // get user details
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
  const handleClickOutsideProfile = (event) => {
    if (
      dropdownProfileRef.current &&
      !dropdownProfileRef.current.contains(event.target)
    ) {
      setShowProfileDropdown(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutsideProfile);
  return () => {
    document.removeEventListener('mousedown', handleClickOutsideProfile);
  };
}, []);



  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const toggleRead = (id) => {
    setNotifications(prev =>
      prev.map(n => n.id === id ? { ...n, read: !n.read } : n)
    );
  };

  return (
    // <header className="w-full fixed top-0 left-0 z-50 bg-white shadow-sm border-b px-4 py-2 pl-10 lg:pl-2 flex flex-wrap justify-between items-center gap-4"></header>
    <header className="w-full fixed top-0 left-0 z-50 bg-[#2d385b] px-4 py-1 pl-10 lg:pl-2 flex flex-wrap justify-between items-center gap-4">
      {/* Left Section: Logo & Company */}
      <div className="flex items-left gap-2">
        <div className="w-16 h-8 rounded-md flex items-center justify-center text-indigo-700 text-lg">
          <div className="align-center flex item-left justify-start pt-1">
              <a href='/'>
              <Webtrix24LogoAnimated
                className="w-full"
                webtrixProps={{
                  whileHover: { scale: 1.04 },
                  transition: { duration: 0.7, type: "spring", stiffness: 200 }
                }}
                twentyFourProps={{
                  whileHover: { scale: 1.09, rotate: 2 },
                  transition: { duration: 0.6, type: "spring", stiffness: 240, delay: 0.6 }
                }}
              />
              </a>
            </div></div>
        <CompanySelector />
      </div>

      {/* Right Section: Responsive container */}
      <div className="flex flex-wrap items-center gap-4 justify-end text-sm text-gray-100">
        {/* Time & Timezone - hidden on small screens */}
        <div className="hidden md:flex items-center gap-2 text-gray-100">
          <Clock className="w-4 h-4 text-indigo-500" />
          <span>{dateTime.toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short', hour12: true, timeZone })}</span>
          <Globe className="w-4 h-4 text-green-600 bg-transparent" />
          <select
            value={timeZone}
            onChange={(e) => {
              const selected = e.target.value;
              setTimeZone(selected);
              localStorage.setItem('user_time_zone', selected);
            }}
            className="rounded px-2 py-1 bg-transparent focus:outline-none"
          >
            <option value="Asia/Kolkata">India (IST)</option>
            <option value="UTC">UTC</option>
            <option value="America/New_York">US (EST)</option>
            <option value="Europe/London">UK (GMT)</option>
            <option value="Asia/Dubai">Dubai</option>
            <option value="Asia/Singapore">Singapore</option>
          </select>
        </div>

        {/* Bell icon - mobile opens full panel */}
        <div className="relative cursor-pointer md:block" onClick={() => {
            setShowDropdown(!showDropdown);
        }}>
          <div className="relative flex items-center justify-center">
            <span className={`absolute inset-0 ${unreadCount > 0 ? 'animate-ping  rounded-full bg-red-300' : ''}`}></span>
            <Bell className={`relative z-10 w-5 h-5 ${unreadCount > 0 ? 'text-white' : 'text-gray-100'}`} />
            {unreadCount > 0 && (
              <span className="absolute -top-2 -right-1.5 translate-x-1 z-20 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">
                {unreadCount}
              </span>
            )}
          </div>
        </div>
        <div className='fixed bottom-2'>
          {/* <MiniAssistant /> */}
        </div>
        {/* Notification dropdown for desktop */}
        {showDropdown && (
          <div className="fixed md:absolute top-0 md:top-12 right-0 md:right-20 left-0 md:left-auto bottom-0 md:bottom-auto w-full md:w-80 md:h-auto h-full md:max-h-96 overflow-y-auto bg-white border rounded md:shadow-lg z-50">
            {/* Header for mobile */}
            <div className="flex items-center justify-between p-3 border-b sticky top-0 bg-white z-10 md:hidden">
              <div className="flex items-center gap-2">
                <ArrowLeft className="cursor-pointer" onClick={() => setShowDropdown(false)} />
                <h2 className="text-lg font-semibold">Notifications</h2>
              </div>
            </div>

            {/* Title for desktop */}
            <div className="font-medium text-sm truncate sticky top-0 bg-white z-10 px-4 py-2 border-b shadow-sm hidden md:block">
              Notifications
            </div>

            {/* Notification list */}
            <div className="px-3 py-2">
              {notifications.length === 0 ? (
                <div className="text-gray-500 text-sm">No notifications</div>
              ) : notifications.map(n => (
                <div key={n.id} className={`flex items-start justify-between gap-2 px-2 py-2 hover:bg-gray-100 rounded ${n.read ? 'opacity-60' : ''}`} tabIndex="0" aria-label={`Notification: ${n.title}`}>  
                  <div className="flex gap-2 flex-1 min-w-0">
                    <div className="mt-1 flex-shrink-0">{iconMap[n.type]}</div>
                    <div className="min-w-0">
                      <div
                        className="font-medium text-sm truncate"
                        title={n.title}
                      >{n.title}
                      </div>
                      <div
                        className="text-xs text-gray-500 truncate"
                        title={n.message}
                      >{n.message}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col items-end justify-between text-xs text-gray-400 whitespace-nowrap">
                    <span>{n.time}</span>
                    <button
                      onClick={() => toggleRead(n.id)}
                      className="text-blue-500 hover:underline p-1 rounded hover:bg-blue-50"
                    >
                      {n.read ? <EyeOff size={14} /> : <Eye size={14} />}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

      )}
        {/* Profile & Logout */}
        {/* <div className="flex items-center gap-2">
               {avatar ? (
          <img
            src={avatar}
            alt={userData['name']}
            className="w-8 h-8 rounded-full object-cover"
          />
        ) : (
          <div className="w-8 h-8 bg-gray-400 rounded-full flex items-center justify-center text-white font-bold text-sm">
            {initials}
          </div>
        )}
          {/* <img src="https://i.pravatar.cc/30?img=3" alt="User" className="w-8 h-8 rounded-full" /> * /}
          <span className="font-medium hidden sm:inline">{ userData?.['name']}</span>
        </div>
        <button
          onClick={handleLogout}
          className="flex items-center gap-1 text-sm text-gray-600 hover:text-red-500"
        >
          <LogOut className="w-4 h-4" />
          <span className="hidden sm:inline">Logout</span>
        </button> */}
        <div ref={dropdownProfileRef} className="relative">
  <button
    className="flex items-center gap-1 cursor-pointer"
    onClick={(e) => {e.preventDefault(); setShowProfileDropdown((prev) => !prev);}}
  >
    {avatar ? (
      <img src={avatar} className="w-8 h-8 rounded-full" />
    ) : (
      <div className="w-8 h-8 bg-gray-400 rounded-full flex items-center justify-center text-white font-bold text-sm">
        {initials}
      </div>
    )}
    <svg
      className={`w-4 h-4 transition-transform duration-200 ${
        showProfileDropdown ? 'rotate-180' : ''
      }`}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  {showProfileDropdown && (
    <ProfileDropdown
      user={userData}
      onLogout={handleLogout}
      onClose={() => setShowProfileDropdown(false)}
    />
  )}
</div>
      </div>
      
    </header>
  );
};

export default TopNavBar;